module.exports = __webpack_public_path__ + "593a3d53/img/note-edit-icon.acae1669.svg";